import { useEffect, useState, } from 'react'
import * as XLSX from 'xlsx';
import { useForm } from 'react-hook-form'
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import FolderUploadLineIcon from 'remixicon-react/FolderUploadLineIcon';
import FileSaver from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import Papa from 'papaparse'
import Button from '../../components/utils/Button'
import SearchBar from '../../components/utils/SearchBar'
import PlanWiseMappingActions from '../../redux/planWiseMapping/actions';
import dealerAction from '../../redux/dealer/actions'
import Table from '../../components/utils/Table'
import SideButtons from '../../components/utils/SideButtons'
import { useNavigate } from "react-router-dom";
import networkActions from '../../redux/network/actions'
import { Link } from 'react-router-dom';
import PencilFill from 'remixicon-react/PencilFillIcon';
import PriceMappingModel from '../../components/utils/PriceMappingModel';
import Alert from '../../components/utils/Alert';

const {
  getPlanWiseMapping,
  getRechargeMapping,
  updateRechargeMappingData,
  openUpdatePortinModal,
  closeUpdatePortinModal,
  resetPlanPriceMappingMessages,
  updateRechargeMappingByDealerId,
  getAdditionalService,
  getAdditionalServiceMapping,
  updateAdditionalServiceMapping,
  updateAdditionalMappingByDealerId
} = PlanWiseMappingActions;
const { getDealer } = dealerAction;

const { getNetwork } = networkActions;

export const AdditionalServiceMapping = () => {
  const dispatch = useDispatch();
  const [uploadPlanPriceMapping, setUploadPlanPriceMapping] = useState(false);
  const {
    rechargeMappingData,
    rechargeMappingLoading,
    updateRechargeMappingLoading,
    updateRechargeMappingMessage,
    openPortinModal,
    updateRechargeMappingByDealerIDLoading,
    updateRechargeMappingByDealerIDError,
    updateRechargeMappingByDealerIDMessage,
    getAdditionalServiceData,
    getAdditionalServiceMappingData,
    updateAdditionalServiceMappingLoading,
    updateAdditionalServiceMappingMessage,
    updateAdditionalServiceMappingError,
    updateAdditionalServiceMappingByDealerIDLoading,
    updateAdditionalServiceMappingByDealerIDMessage
  } = useSelector((state) => state.planWiseMapping);
  const { networkResult } = useSelector((state) => state.network);
  const { dealerResult } = useSelector((state) => state.dealer);
  const [previewSubmitBtn, setPreviewSubmitBtn] = useState(true);
  const navigate = useNavigate();


  useEffect(() => {
    setPreviewHeading([]);
    dispatch(getPlanWiseMapping());
    dispatch(getRechargeMapping());
    dispatch(getDealer());
    dispatch(getNetwork());
    dispatch(getAdditionalService());
    dispatch(getAdditionalServiceMapping());
  }, []);

  useEffect(() => {
    if (updateAdditionalServiceMappingMessage) {
      setUploadPlanPriceMapping(false);
    }
  }, [updateAdditionalServiceMappingMessage]);

  useEffect(() => {
    if (updateAdditionalServiceMappingError !== null && updateAdditionalServiceMappingError !== undefined) {
      displayAlert(updateAdditionalServiceMappingError, 'alert-danger');
    }
    if (updateAdditionalServiceMappingMessage !== null && updateAdditionalServiceMappingMessage !== undefined) {
      displayAlert(updateAdditionalServiceMappingMessage, 'alert-success');
    }
    if (updateAdditionalServiceMappingByDealerIDMessage !== null && updateAdditionalServiceMappingByDealerIDMessage !== undefined) {
      displayAlert(updateAdditionalServiceMappingByDealerIDMessage, 'alert-success');
    }
  }, [updateAdditionalServiceMappingError, updateAdditionalServiceMappingMessage, updateAdditionalServiceMappingByDealerIDMessage]);


  const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();

  const [filterText, setFilterText] = useState("");
  const [uploadedMapping, setUploadedMapping] = useState([]);
  const [previewHeading, setPreviewHeading] = useState([]);
  const [previewDataSourceExcel, setPreviewDataSourceExcel] = useState([]);
  const [dealerID, setDealerID] = useState(null);
  const [dealerName, setDealerName] = useState(null);
  const [priceMappingData, setPriceMappingData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertText, setAlertText] = useState('');
  const networkData = networkResult && networkResult.length > 0 && networkResult.map((item) => item.NetworkName);
  const additionalServiceData = getAdditionalServiceData && getAdditionalServiceData.length > 0 && getAdditionalServiceData.map((item) => item.ServiceName)
  const newHeadingData = additionalServiceData && additionalServiceData.flat().map(item => ({ displayName: item, key: item }));

  const heading = [
    { displayName: '#', key: 'key' },
    { displayName: 'Dealer', key: 'dealerName' },
    ...(newHeadingData || []),
    { displayName: 'Action', key: 'action' },
  ];

  const newDataSource = Object.values(getAdditionalServiceMappingData && getAdditionalServiceMappingData.length > 0 && getAdditionalServiceMappingData.reduce((acc, item) => {
    const { DealerID, DealerName, DealerPrice, ServiceName } = item;
    const plannewHeading = `${ServiceName}`
    if (!acc[DealerID]) {
      acc[DealerID] = { DealerID, DealerName };
    }
    acc[DealerID][plannewHeading] = DealerPrice;
    return acc;
  }, {}));

  const Keys = newDataSource && newDataSource.length > 0 && getAdditionalServiceMappingData.map((item) => item.ServiceName);

  const filteredItems = Array.isArray(newDataSource) && newDataSource.length > 0 ? newDataSource.filter(item => {
    if (typeof filterText !== 'string' || typeof item !== 'object') return false;
    // Check if any value in the object contains the filterText
    return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
  }) : [];

  const DataSource = filteredItems && filteredItems.length > 0 && filteredItems.map((item, index) => {
    const obj = { key: index + 1, dealerName: item.DealerName, };
    Keys.forEach(key => {
      obj[key] = item[key] ? `$${item[key]}` : '';
    });
    obj.action = (
      <Link to="#">
        <span data-toggle="tooltip" data-placement="top" title="Edit">
          <PencilFill size="1.4em" style={{ color: "#888b8e", marginRight: "3px", cursor: "pointer" }}
            onClick={() => handleclickModel(item)} />
        </span>
      </Link>
    );
    return obj;
  });

  const handleclickModel = (data) => {
    setDealerID(data.DealerID)
    setDealerName(data.DealerName)
    const newArrayData = getAdditionalServiceMappingData && getAdditionalServiceMappingData.length > 0 && getAdditionalServiceMappingData.filter(item => item.DealerID == data.DealerID);

    const result = getAdditionalServiceData.map(item1 => {
      const matched = newArrayData.find(item2 => item2.ServiceID === item1.ID);
      if (matched) {
        return {
          networkID: item1.ID,
          dealerPrice: matched.DealerPrice,
          networkName: item1.ServiceName
        };
      } else {
        return {
          networkID: item1.ID,
          dealerPrice: 0,
          networkName: item1.ServiceName
        };
      }
    });
    setPriceMappingData(result)
    dispatch(openUpdatePortinModal())
  };

  const handleCloseModal = () => {
    dispatch(closeUpdatePortinModal())
  };
  const handleUpdate = (data) => {
    const updateData = data.prices.map((item, ind) => ({
      ...item,
      dealerPrice: item.dealerPrice === "" ? 0 : item.dealerPrice,
      serviceID: priceMappingData[ind].networkID,
    }));

    dispatch(updateAdditionalMappingByDealerId(dealerID, updateData));
  };

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
    dispatch(resetPlanPriceMappingMessages());
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText('');
    setAlertType('');
    dispatch(resetPlanPriceMappingMessages());
  }

  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const uploadView = () => {
    setUploadPlanPriceMapping(true);
  }

  const closeUploadView = () => {
    setUploadPlanPriceMapping(false);
    setPreviewSubmitBtn(true)
    setPreviewHeading([])
  }

  const dealerData = dealerResult && dealerResult.length > 0 && dealerResult.filter((item) => item.ParentID != 0).map((item) => {
    return {
      name: item.DealerName,
      dealerId: item.ID
    }
  });

  const exportToCSV = async () => {
    const transformedData = {};

    getAdditionalServiceMappingData.forEach(item => {
      if (!transformedData[item.DealerName]) {
        transformedData[item.DealerName] = {
          name: item.DealerName,
          dealerId: item.DealerID
        };
      }
      transformedData[item.DealerName][`${item.ServiceName}`] = item.DealerPrice;
    });

    const resultArray = Object.values(transformedData);

    const topRowNetworks = additionalServiceData.flat(1);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([['Dealer Name', 'Dealer ID', ...additionalServiceData.flat(1)]]);
    let dealerColIndex = 1;

    if (resultArray && resultArray.length > 0) {
      resultArray && resultArray.length > 0 && resultArray.forEach((planData) => {
        let newRow = [];
        const keys = Object.keys(planData);
        const dealerRow = keys.map(key => planData[key]);
        newRow.push(dealerRow[0]);
        newRow.push(dealerRow[1]);

        topRowNetworks.forEach((item) => {
          if (planData[item]) {
            newRow.push(planData[item]);
          } else {
            newRow.push(0);
          }
        });

        XLSX.utils.sheet_add_aoa(ws, [newRow], { origin: { r: dealerColIndex, c: 0 } });
        dealerColIndex += 1;
      })
    } else {
      dealerData.forEach((dealer) => {
        const dealerRow = [dealer.name, dealer.dealerId];
        XLSX.utils.sheet_add_aoa(ws, [dealerRow], { origin: { r: dealerColIndex, c: 0 } });
        dealerColIndex += 1;
      });
    }

    XLSX.utils.book_append_sheet(wb, ws, 'Recharge Price Mapping');
    const excelBuffer = XLSX.write(wb, { bookType: 'csv', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    let fileName = "Existing Additional Service Plan Price";
    FileSaver.saveAs(data, `${fileName}.csv`);
  }

  const handleFileChange = (e) => {
    const fileReader = new FileReader();
    let file = e.target.files[0];
    let uploadedData = [];
    if (file) {
      fileReader.onload = async ({ target }) => {
        const csvOutput = Papa.parse(target.result, { header: true });
        const parsedData = csvOutput?.data;
        const columns = Object.keys(parsedData[0]);
        let customizeData = [];

        getAdditionalServiceData.map((item) => {
          customizeData.push({
            column: `${item.ServiceName}`,
            serviceID: item.ID
          });
        });

        dealerData.forEach((dealer) => {
          customizeData.forEach((item) => {
            let row = parsedData.filter((item1) => item1['Dealer ID'] == dealer.dealerId);
            if (row.length > 0) {
              uploadedData.push({
                dealerId: dealer.dealerId,
                dealerName: dealer.name,
                serviceID: item.serviceID,
                planHeading: item.column,
                dealerPrice: row[0][item.column]
              });
            } else {
              console.error(`No data found for dealer with ID ${dealer.dealerId}`);
            }
          });
        });

        const uniquePlanIds = [...new Set(uploadedData.map(item => item.planHeading))];

        const heading = [
          { displayName: '#', key: 'key' },
          { displayName: 'Dealer', key: 'dealerName' },
          ...uniquePlanIds.map(id => ({ displayName: `${id}`, key: `${id}` }))
        ];

        setPreviewHeading(heading)
        const groupedData = uploadedData.reduce((acc, item) => {
          const { dealerId, dealerName, planHeading, dealerPrice } = item;
          if (!acc[dealerId]) {
            acc[dealerId] = { dealerId, dealerName };
          }
          acc[dealerId][planHeading] = `${dealerPrice}$` || `0`;
          return acc;
        }, {});
        setPreviewDataSourceExcel(Object.values(groupedData))
        setUploadedMapping(uploadedData);
        setPreviewSubmitBtn(false);

      };
      fileReader.readAsText(file);
    }
  }

  const previewColumns = previewHeading
  const PreviewKeys = previewDataSourceExcel && previewDataSourceExcel.length > 0 && Object.keys(previewDataSourceExcel[0]);
  var previewDataSource = previewDataSourceExcel && previewDataSourceExcel.length > 0 && previewDataSourceExcel.map((plan, index) => {
    const obj = { key: index + 1 };
    PreviewKeys.forEach(key => {
      obj[key] = plan[key];
    });
    return obj;
  });


  const onSubmit = (data) => {
    let UpdateDataArray = [];
    let insertedArray = [];
    let deletedArray = [];

    console.log("Uploaded Mapping:", uploadedMapping);
    console.log("Additional Service Mapping Data:", getAdditionalServiceMappingData);

    uploadedMapping.forEach((firstItem) => {
      if (parseFloat(firstItem.dealerPrice) > 0) {
        let matchFound = false;
        getAdditionalServiceMappingData.forEach((secondItem) => {
          if (firstItem.dealerId === secondItem.DealerID && firstItem.serviceID === secondItem.ServiceID) {
            matchFound = true;
            UpdateDataArray.push(firstItem);
          }
        });
        if (!matchFound) {
          insertedArray.push(firstItem);
        }
      }
    });

    getAdditionalServiceMappingData.forEach((firstItem) => {
      uploadedMapping.forEach((secondItem) => {
        if (firstItem.DealerID === secondItem.dealerId && firstItem.ServiceID === secondItem.serviceID && (secondItem.dealerPrice == 0 || secondItem.dealerPrice == null)) {
          deletedArray.push({
            dealerId: firstItem.DealerID,
            serviceID: firstItem.ServiceID,
            dealerPrice: secondItem.dealerPrice ?? 0
          });
        }
      });
    });

    const finalData = { "insertData": insertedArray, "updateData": UpdateDataArray, "deleteData": deletedArray };
    reset();
    dispatch(updateAdditionalServiceMapping(finalData));
  }

  const handleSideButton = () => {
    if (networkResult.length <= 0) {
      navigate("/network");
    } else if (dealerResult.length <= 0) {
      navigate("/dealer");
    }
  }

  return (
    <>
      {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}

      {
        !uploadPlanPriceMapping ? <>
          <div className='row align-items-baseline'>
            <div className="col-md-6 od-2">
              <SearchBar onFilter={handleFilterChange} filterText={filterText} /></div>
            <div className="col-md-6  text-right">
              {
                networkResult.length <= 0 ?
                  <SideButtons title="Add Network" buttonStyle="primary" onClick={handleSideButton} /> :
                  dealerResult.length <= 0 ?
                    <SideButtons title="Add Dealer" buttonStyle="primary" onClick={handleSideButton} /> :
                    <Button icon={<FolderUploadLineIcon color='#fff' className='mr-1' size={'0.9rem'} />} title='Upload' buttonClass="btn btn-primary float-right ml-2" onClick={uploadView} loading={false} buttonType='submit' />
              }
            </div>
          </div>

          <Table data={DataSource} columns={heading} loading={rechargeMappingLoading} />
        </> :
          <>
            <div className='row align-items-center mb-4'>
              <div className="col-md-12 text-right">
                <Button icon={<DownloadCloud2sLineIcon color='#fff' className='mr-1' size={'0.9rem'} />} title='Existing Additional Service Mapping' buttonClass="btn btn-primary float-right" onClick={exportToCSV} loading={false} buttonType='submit' />
              </div>
            </div>

            <div className="row">
              <div className='col-md-12'>
                <form className="form px-4" onSubmit={handleSubmit(onSubmit)}>
                  <div className="input-group">
                    <label htmlFor="csvFile"><span className='text-danger'>*</span>Upload File </label>
                    <input
                      type="file"
                      className="form-control-file"
                      name='uploadedFile'
                      id="csvFile"
                      accept='.csv'
                      {...register('uploadedFile', { required: true })}
                      onChange={(e) => handleFileChange(e)}
                    />
                  </div>

                  {previewHeading && previewHeading.length > 0 && <Table data={previewDataSource} loading={false} columns={previewColumns} />}

                  <div className='text-right row mt-2'>
                    <div className="col-md-12">
                      <button type="button" className="btn btn-secondary mr-2" onClick={closeUploadView}>Close</button>
                      <Button title="Submit" disable={previewSubmitBtn} style="minWidth:80px" buttonClass="btn btn-primary" loading={updateAdditionalServiceMappingLoading} buttonType='submit' />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
      }

      <PriceMappingModel
        showModal={openPortinModal}
        title={`Update Additional Service Mapping: ${dealerName}`}
        handleCancel={handleCloseModal}
        buttonTitle={"Submit"}
        submitData={handleUpdate}
        priceMappingData={priceMappingData}
        loading={updateAdditionalServiceMappingByDealerIDLoading}
      />
    </>
  )
}
